// export const Marketdata = [
//   {
//     area: "ALASKA",
//     id: 47,
//     market: "ALASKA",
//     region: "WEST",
//     row: 0,
//     column: 1,
//     abbrev: "AK",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MAINE",
//     region: "SOUTH",
//     row: 0,
//     column: 12,
//     abbrev: "ME",
//   },
//   {
//     area: "VERMONT",
//     id: 3,
//     market: "VERMONT",
//     region: "SOUTH",
//     row: 1,
//     column: 10,
//     abbrev: "VT",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 1,
//     column: 11,
//     abbrev: "ME",
//   },

//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 2,
//     abbrev: "WA",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 3,
//     abbrev: "MT",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 4,
//     abbrev: "MD",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 5,
//     abbrev: "MN",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 6,
//     abbrev: "WI",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 7,
//     abbrev: "WI",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 10,
//     abbrev: "WI",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 11,
//     abbrev: "WI",
//   },
//   {
//     area: "GEORGIA/TN",
//     id: 3,
//     market: "MEMPHIS",
//     region: "SOUTH",
//     row: 2,
//     column: 12,
//     abbrev: "WI",
//   },

//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 2,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 3,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 4,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 5,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 6,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 7,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 8,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 9,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 10,
//     abbrev: "CL",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 33,
//     market: "CLEVELAND",
//     region: "CENTRAL",
//     row: 3,
//     column: 11,
//     abbrev: "CL",
//   },

//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 2,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 3,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 4,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 5,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 6,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 7,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 8,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 9,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 10,
//     abbrev: "CE",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 9,
//     market: "COLUMBUS",
//     region: "CENTRAL",
//     row: 4,
//     column: 11,
//     abbrev: "CE",
//   },

//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 3,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 4,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 5,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 6,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 7,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 8,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 9,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 10,
//     abbrev: "KX",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 21,
//     market: "KNOXVILLE TN",
//     region: "CENTRAL",
//     row: 5,
//     column: 11,
//     abbrev: "KX",
//   },

//   {
//     area: "APPALACHIAN",
//     id: 17,
//     market: "LOUISVILLE",
//     region: "CENTRAL",
//     row: 6,
//     column: 4,
//     abbrev: "LO",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 17,
//     market: "LOUISVILLE",
//     region: "CENTRAL",
//     row: 6,
//     column: 5,
//     abbrev: "LO",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 17,
//     market: "LOUISVILLE",
//     region: "CENTRAL",
//     row: 6,
//     column: 6,
//     abbrev: "LO",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 17,
//     market: "LOUISVILLE",
//     region: "CENTRAL",
//     row: 6,
//     column: 7,
//     abbrev: "LO",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 17,
//     market: "LOUISVILLE",
//     region: "CENTRAL",
//     row: 6,
//     column: 8,
//     abbrev: "LO",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 17,
//     market: "LOUISVILLE",
//     region: "CENTRAL",
//     row: 6,
//     column: 9,
//     abbrev: "LO",
//   },

//   {
//     area: "APPALACHIAN",
//     id: 16,
//     market: "NASHVILLE",
//     region: "CENTRAL",
//     row: 7,
//     column: 0,
//     abbrev: "NA",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 16,
//     market: "NASHVILLE",
//     region: "CENTRAL",
//     row: 7,
//     column: 6,
//     abbrev: "NA",
//   },
//   {
//     area: "APPALACHIAN",
//     id: 16,
//     market: "NASHVILLE",
//     region: "CENTRAL",
//     row: 7,
//     column: 9,
//     abbrev: "NA",
//   },
// ];

// export const markets = {
//   NATIONAL: "NA",
//   ALASKA: "AK",
//   "ALBUQUERQUE NM": "AL",
//   ARKANSAS: "AR",
//   ATLANTA: "AT",
//   "AUSTIN TX": "AU",
//   BIRMINGHAM: "BH",
//   "CENTRAL PA": "PC",
//   CHICAGO: "CH",
//   CINCINNATI: "CI",
//   CLEVELAND: "CL",
//   COLUMBUS: "CB",
//   CONNECTICUT: "CT",
//   // DAKOTAS: 'DO',
//   "DALLAS TX": "DA",
//   "DENVER CO": "DN",
//   "DES MOINES IA": "DM",
//   "DETROIT MI": "DE",
//   // 'EL PASO TX': 'EP',
//   "HAWAII HI": "HI",
//   "HOUSTON TX": "HN",
//   "INDIANAPOLIS IN": "IN",
//   JACKSONVILLE: "JV",
//   "KANSAS CITY KS": "KC",
//   "KNOXVILLE TN": "KX",
//   "LA NORTH": "SV",
//   "LAS VEGAS": "VG",
//   "LONG ISLAND - NY": "LI",
//   "LOS ANGELES": "LA",
//   LOUISVILLE: "LU",
//   MEMPHIS: "ME",
//   "MIAMI FL": "FL",
//   MILWAUKEE: "ML",
//   "MINNEAPOLIS MN": "MN",
//   MOBILE: "MO",
//   MONTANA: "MT",
//   NASHVILLE: "NA",
//   "NEW ENGLAND MARKET": "NE",
//   "NEW JERSEY NJ": "NJ",
//   "NEW YORK NY": "NY",
//   "NORTH CAROLINA": "NC",
//   "NY (UPSTATE)": "UP",
//   "OKLAHOMA CITY OK": "OK",
//   OMAHA: "ON",
//   ORLANDO: "OR",
//   "PHILADELPHIA PA": "PH",
//   PHOENIX: "PX",
//   "PITTSBURGH PA": "PB",
//   "PORTLAND OR": "PT",
//   "PUERTO RICO": "PR",
//   SACRAMENTO: "SC",
//   "SALT LAKE CITY UT": "UT",
//   "SAN DIEGO": "SD",
//   "SAN FRANCISCO": "SF",
//   // "SEATTLE WA": "SE",
//   "SOUTH CAROLINA": "CR",
//   "SOUTHERN CALIFORNIA": "IE",
//   "SPOKANE WA": "SP",
//   "ST. LOUIS": "SL",
//   "TAMPA FL": "TP",
//   // 'TULSA OK': 'TU',
//   VIRGINIA: "VA",
//   "Washington DC": "DC",
//   "WEST VIRGINIA": "WV",
//   // 'WICHITA KS': 'WI',
// };

export const Marketdata = [
  {
    area: "ALASKA",
    id: 47,
    market: "ALASKA",
    region: "WEST",
    row: 0,
    column: 1,
    abbrev: "AK",
  },
  {
    area: "MAINE",
    id: 3,
    market: "MAINE",
    region: "SOUTH",
    row: 0,
    column: 12,
    abbrev: "ME",
  },
  {
    area: "PUERTO RICO",
    id: 3,
    market: "PUERTO RICO",
    region: "SOUTH",
    row: 1,
    column: 10,
    abbrev: "PR",
  },
  {
    area: "NEW HAMPSHIRE",
    id: 3,
    market: "NEW HAMPSHIRE",
    region: "SOUTH",
    row: 1,
    column: 11,
    abbrev: "NH",
  },

  {
    area: "Washington",
    id: 3,
    market: "Washington",
    region: "SOUTH",
    row: 2,
    column: 2,
    abbrev: "WA",
  },
  {
    area: "MONTANA",
    id: 3,
    market: "MONTANA",
    region: "SOUTH",
    row: 2,
    column: 3,
    abbrev: "MT",
  },
  {
    area: "North Dakota",
    id: 3,
    market: "North Dakota",
    region: "SOUTH",
    row: 2,
    column: 4,
    abbrev: "ND",
  },
  {
    area: "MINNESOTA",
    id: 3,
    market: "MINNESOTA",
    region: "SOUTH",
    row: 2,
    column: 5,
    abbrev: "MN",
  },
  {
    area: "WISCONSIN",
    id: 3,
    market: "WISCONSIN",
    region: "SOUTH",
    row: 2,
    column: 6,
    abbrev: "WI",
  },
  {
    area: "MICHIGAN",
    id: 3,
    market: "MICHIGAN",
    region: "SOUTH",
    row: 2,
    column: 8,
    abbrev: "MI",
  },
  {
    area: "NEW YORK",
    id: 3,
    market: "NEW YORK",
    region: "SOUTH",
    row: 2,
    column: 10,
    abbrev: "NY",
  },
  {
    area: "MASSACHUSETTS",
    id: 3,
    market: "MASSACHUSETTS",
    region: "SOUTH",
    row: 2,
    column: 11,
    abbrev: "MA",
  },
  {
    area: "RHODE ISLAND",
    id: 3,
    market: "RHODE ISLAND",
    region: "SOUTH",
    row: 2,
    column: 12,
    abbrev: "RI",
  },
  {
    area: "IDAHO",
    id: 33,
    market: "IDAHO",
    region: "CENTRAL",
    row: 3,
    column: 2,
    abbrev: "ID",
  },
  {
    area: "WYOMING",
    id: 33,
    market: "WYOMING",
    region: "CENTRAL",
    row: 3,
    column: 3,
    abbrev: "WY",
  },
  {
    area: "SOUTH DAKOTA",
    id: 33,
    market: "SOUTH DAKOTA",
    region: "CENTRAL",
    row: 3,
    column: 4,
    abbrev: "SD",
  },
  {
    area: "IOWA",
    id: 33,
    market: "IOWA",
    region: "CENTRAL",
    row: 3,
    column: 5,
    abbrev: "IA",
  },
  {
    area: "ILLINOIS",
    id: 33,
    market: "ILLINOIS",
    region: "CENTRAL",
    row: 3,
    column: 6,
    abbrev: "IL",
  },
  {
    area: "INDIANA",
    id: 33,
    market: "INDIANA",
    region: "CENTRAL",
    row: 3,
    column: 7,
    abbrev: "IN",
  },
  {
    area: "OHIO",
    id: 33,
    market: "OHIO",
    region: "CENTRAL",
    row: 3,
    column: 8,
    abbrev: "OH",
  },
  {
    area: "PENNSYLVANIA",
    id: 33,
    market: "PENNSYLVANIA",
    region: "CENTRAL",
    row: 3,
    column: 9,
    abbrev: "PA",
  },
  {
    area: "NEW JERSEY",
    id: 33,
    market: "NEW JERSEY",
    region: "CENTRAL",
    row: 3,
    column: 10,
    abbrev: "NJ",
  },
  {
    area: "CONNECTICUT",
    id: 33,
    market: "CONNECTICUT",
    region: "CENTRAL",
    row: 3,
    column: 11,
    abbrev: "CT",
  },

  {
    area: "OREGON",
    id: 9,
    market: "OREGON",
    region: "CENTRAL",
    row: 4,
    column: 2,
    abbrev: "OR",
  },
  {
    area: "NEVADA",
    id: 9,
    market: "NEVADA",
    region: "CENTRAL",
    row: 4,
    column: 3,
    abbrev: "NV",
  },
  {
    area: "COLORADO",
    id: 9,
    market: "COLORADO",
    region: "CENTRAL",
    row: 4,
    column: 4,
    abbrev: "CO",
  },
  {
    area: "NEBRASKA",
    id: 9,
    market: "NEBRASKA",
    region: "CENTRAL",
    row: 4,
    column: 5,
    abbrev: "NE",
  },
  {
    area: "MISSOURI",
    id: 9,
    market: "MISSOURI",
    region: "CENTRAL",
    row: 4,
    column: 6,
    abbrev: "MO",
  },
  {
    area: "KENTUCKY",
    id: 9,
    market: "KENTUCKY",
    region: "CENTRAL",
    row: 4,
    column: 7,
    abbrev: "KY",
  },
  {
    area: "WEST VIRGINIA",
    id: 9,
    market: "WEST VIRGINIA",
    region: "CENTRAL",
    row: 4,
    column: 8,
    abbrev: "WV",
  },
  {
    area: "VIRGINIA",
    id: 9,
    market: "VIRGINIA",
    region: "CENTRAL",
    row: 4,
    column: 9,
    abbrev: "VA",
  },
  {
    area: "MARYLAND",
    id: 3,
    market: "MARYLAND",
    region: "SOUTH",
    row: 4,
    column: 10,
    abbrev: "MD",
  },
  {
    area: "DELAWARE",
    id: 9,
    market: "DELAWARE",
    region: "CENTRAL",
    row: 4,
    column: 11,
    abbrev: "DE",
  },

  {
    area: "CALIFORNIA",
    id: 9,
    market: "CALIFORNIA",
    region: "CENTRAL",
    row: 5,
    column: 2,
    abbrev: "CA",
  },

  {
    area: "UTAH",
    id: 21,
    market: "UTAH",
    region: "CENTRAL",
    row: 5,
    column: 3,
    abbrev: "UT",
  },
  {
    area: "NEW MEXICO",
    id: 21,
    market: "NEW MEXICO",
    region: "CENTRAL",
    row: 5,
    column: 4,
    abbrev: "NM",
  },
  {
    area: "KANSAS",
    id: 21,
    market: "KANSAS",
    region: "CENTRAL",
    row: 5,
    column: 5,
    abbrev: "KS",
  },
  {
    area: "ARKANSAS",
    id: 21,
    market: "ARKANSAS",
    region: "CENTRAL",
    row: 5,
    column: 6,
    abbrev: "AR",
  },
  {
    area: "TENNESSEE",
    id: 21,
    market: "TENNESSEE",
    region: "CENTRAL",
    row: 5,
    column: 7,
    abbrev: "TN",
  },
  {
    area: "NORTH CAROLINA",
    id: 21,
    market: "NORTH CAROLINA",
    region: "CENTRAL",
    row: 5,
    column: 8,
    abbrev: "NC",
  },
  {
    area: "SOUTH CAROLINA",
    id: 21,
    market: "SOUTH CAROLINA",
    region: "CENTRAL",
    row: 5,
    column: 9,
    abbrev: "SC",
  },
  {
    area: "DISTRICT OF COLUMBIA",
    id: 21,
    market: "DISTRICT OF COLUMBIA",
    region: "CENTRAL",
    row: 5,
    column: 10,
    abbrev: "DC",
  },
  {
    area: "ARIZONA",
    id: 21,
    market: "ARIZONA",
    region: "CENTRAL",
    row: 6,
    column: 4,
    abbrev: "AZ",
  },
  {
    area: "OKLAHOMA",
    id: 17,
    market: "OKLAHOMA",
    region: "CENTRAL",
    row: 6,
    column: 5,
    abbrev: "OK",
  },
  {
    area: "LOUISIANA",
    id: 17,
    market: "LOUISIANA",
    region: "CENTRAL",
    row: 6,
    column: 6,
    abbrev: "LA",
  },
  {
    area: "MISSISSIPPI",
    id: 17,
    market: "MISSISSIPPI",
    region: "CENTRAL",
    row: 6,
    column: 7,
    abbrev: "MS",
  },
  {
    area: "ALABAMA",
    id: 17,
    market: "ALABAMA",
    region: "CENTRAL",
    row: 6,
    column: 8,
    abbrev: "AL",
  },
  {
    area: "GEORGIA",
    id: 17,
    market: "GEORGIA",
    region: "CENTRAL",
    row: 6,
    column: 9,
    abbrev: "GA",
  },
  {
    area: "HAWAII",
    id: 17,
    market: "HAWAII",
    region: "CENTRAL",
    row: 7,
    column: 0,
    abbrev: "HI",
  },

  {
    area: "TEXAS",
    id: 16,
    market: "TEXAS",
    region: "CENTRAL",
    row: 7,
    column: 5,
    abbrev: "TX",
  },
  {
    area: "FLORIDA",
    id: 16,
    market: "FLORIDA",
    region: "CENTRAL",
    row: 7,
    column: 8,
    abbrev: "FL",
  },
];

export const markets = {
  ALASKA: "AK",
  MAINE: "ME",
  // VERMONT: "VT",
  "PUERTO RICO": "PR",
  "NEW HAMPSHIRE": "NH",
  Washington: "WA",
  MONTANA: "MT",
  MARYLAND: "MD",
  MINNESOTA: "MN",
  WISCONSIN: "WI",
  MICHIGAN: "MI",
  "NEW YORK": "NY",
  MASSACHUSETTS: "MA",
  "RHODE ISLAND": "RI",
  "North Dakota": "ND",
  IDAHO: "ID",
  WYOMING: "WY",
  "SOUTH DAKOTA": "SD",
  IOWA: "IA",
  ILLINOIS: "IL",
  INDIANA: "IN",
  OHIO: "OH",
  PENNSYLVANIA: "PA",
  "NEW JERSEY": "NJ",
  CONNECTICUT: "CT",
  OREGON: "OR",
  NEVADA: "NV",
  COLORADO: "CO",
  NEBRASKA: "NE",
  MISSOURI: "MO",
  KENTUCKY: "KY",
  "WEST VIRGINIA": "WV",
  VIRGINIA: "VA",
  DELAWARE: "DE",
  CALIFORNIA: "CA",
  UTAH: "UT",
  "NEW MEXICO": "NM",
  KANSAS: "KS",
  ARKANSAS: "AR",
  TENNESSEE: "TN",
  "NORTH CAROLINA": "NC",
  "SOUTH CAROLINA": "SC",
  "DISTRICT OF COLUMBIA": "DC",
  ARIZONA: "AZ",
  OKLAHOMA: "OK",
  LOUISIANA: "LA",
  MISSISSIPPI: "MS",
  ALABAMA: "AL",
  GEORGIA: "GA",
  HAWAII: "HI",
  TEXAS: "TX",
  FLORIDA: "FL",
};

const marketsCohort = {
  NATIONAL: "others",
  ALASKA: "others",
  "ALBUQUERQUE NM": "3",
  ARKANSAS: "3",
  ATLANTA: "1",
  "AUSTIN TX": "1",
  BIRMINGHAM: "3",
  "CENTRAL PA": "3",
  CHICAGO: "1",
  CINCINNATI: "3",
  CLEVELAND: "3",
  COLUMBUS: "3",
  CONNECTICUT: "3",
  DAKOTAS: "DO",
  "DALLAS TX": "1",
  "DENVER CO": "2",
  "DES MOINES IA": "3",
  "DETROIT MI": "1",
  "EL PASO TX": "others",
  "HAWAII HI": "3",
  "HOUSTON TX": "1",
  "INDIANAPOLIS IN": "3",
  JACKSONVILLE: "2",
  "KANSAS CITY KS": "2",
  "KNOXVILLE TN": "3",
  "LA NORTH": "2",
  "LAS VEGAS": "3",
  "LONG ISLAND - NY": "3",
  "LOS ANGELES": "1",
  LOUISVILLE: "3",
  MEMPHIS: "3",
  "MIAMI FL": "1",
  MILWAUKEE: "3",
  "MINNEAPOLIS MN": "2",
  MOBILE: "2",
  MONTANA: "3",
  NASHVILLE: "3",
  "NEW ENGLAND MARKET": "1",
  "NEW JERSEY NJ": "1",
  "NEW YORK NY": "1",
  "NORTH CAROLINA": "1",
  "NY (UPSTATE)": "2",
  "OKLAHOMA CITY OK": "2",
  OMAHA: "3",
  ORLANDO: "2",
  "PHILADELPHIA PA": "1",
  PHOENIX: "2",
  "PITTSBURGH PA": "3",
  "PORTLAND OR": "3",
  "PUERTO RICO": "3",
  SACRAMENTO: "2",
  "SALT LAKE CITY UT": "2",
  "SAN DIEGO": "3",
  "SAN FRANCISCO": "1",
  "SEATTLE WA": "2",
  "SOUTH CAROLINA": "2",
  "SOUTHERN CALIFORNIA": "1",
  "SPOKANE WA": "3",
  "ST. LOUIS": "2",
  "TAMPA FL": "2",
  "TULSA OK": "others",
  VIRGINIA: "2",
  "Washington DC": "1",
  "WEST VIRGINIA": "3",
  "WICHITA KS": "others",
};

const performanceCategories = ["low", "medium", "high"];

const assignRandomPerformance = (data) => {
  return data.map((market) => {
    const randomPerformance =
      performanceCategories[
        Math.floor(Math.random() * performanceCategories.length)
      ];
    const MarketAbbrev = markets[market?.market];
    const MarketCohort =
      marketsCohort[market?.market] === "others"
        ? marketsCohort[market?.market]
        : `cohort ${marketsCohort[market?.market]}`;
    // const randomValueTwoDecimals = Math.floor(Math.random() * 700);
    const randomValueTwoDecimals = 0;
    return {
      ...market,
      performance: randomPerformance,
      abbrev: MarketAbbrev,
      cohort: MarketCohort,
      value: randomValueTwoDecimals,
      isPartner: false,
    };
  });
};

// Function to calculate counts for each performance category
const calculatePerformanceCounts = (data) => {
  return data.reduce((counts, market) => {
    const category = market.performance;
    counts[category] = (counts[category] || 0) + 1;
    return counts;
  }, {});
};

// Assign performance categories
const data = assignRandomPerformance(Marketdata);
const performanceCounts = calculatePerformanceCounts(data);

export const updatedMarketData = {
  data: data,
  colorMapping: {
    low: "#FDDDD7",
    medium: "#F99C89",
    high: "#F96C50",
  },
  legend: {
    low: {
      color: "#FDDDD7",
      value: performanceCounts.low || 0,
      border: "#FFC5BA",
    },
    medium: {
      color: "#F99C89",
      value: performanceCounts.medium || 0,
      border: "#E56147",
    },
    high: {
      color: "#F96C50",
      value: performanceCounts.high || 0,
      border: "#B73218",
    },
    partner: {
      color: "#E9E9EA",
      border: "#D0D0D0",
      label: "Partner ESA",
    },
  },
};
